import colors from '../tokens/colors';

/*
  NOTE: the input `states` styles are base styles for the other "input" components, such as:
    - Input
    - Select
    - Autocomplete
    - Email
    - Phone
*/

// for the states, set CSS properties directly set from this file because of vaious design (states) for each theme

export const inputGetolo = {
  base: {
    border: {
      radius: 4,
      size: '1px solid',
      color: colors.PROFESSIONAL_BLUE,
    },
    height: {
      mobile: '3.5rem',
    },
    outline: {
      size: '1px solid',
      color: colors.PROFESSIONAL_BLUE,
      offset: -1,
    },
    typography: 'body',
  },
  states: {
    hover: {
      outlineWidth: 2,
    },
    focus: {
      outlineWidth: 3,
      outlineOffset: 1.5,
    },
    focusVisible: {
      outlineWidth: 3,
      outlineOffset: 1.5,
    },
    disabled: {
      opacity: 0.35,
    },
  },
};

export const inputDaDirekt = {
  base: {
    border: {
      size: '1px solid',
      color: colors.DA_DIREKT_BORDER_LINES,
      radius: 4,
    },
    height: {
      mobile: '3.5rem',
    },
    outline: {
      size: '1px solid',
      color: colors.DA_DIREKT_BORDER_LINES,
      offset: -1,
    },
    typography: 'body',
  },
  states: {
    hover: {
      outlineWidth: null,
    },
    focus: {
      outlineWidth: 2,
      outlineColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
    focusVisible: {
      outlineWidth: 2,
      outlineColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
      outlineOffset: 2,
    },
    disabled: {
      opacity: 0.35,
    },
  },
};

export const inputDaKaufland = {
  base: {
    border: {
      radius: 0,
      size: '2px solid',
      color: colors.DA_KAUFLAND_GRAY_1,
    },
    height: {
      mobile: '2.75rem',
    },
    outline: {
      size: '2px solid',
      color: colors.DA_KAUFLAND_GRAY_1,
      offset: -2,
    },
    typography: 'p4',
  },
  states: {
    hover: {
      outlineWidth: null,
    },
    focus: {
      outlineWidth: 2,
      outlineColor: colors.DA_KAUFLAND_RED,
    },
    focusVisible: {
      outlineWidth: 2,
      outlineColor: colors.DA_KAUFLAND_RED,
      outlineOffset: 2,
    },
    disabled: {
      opacity: 0.35,
    },
  },
};

export const inputFressnapf = {
  base: {
    border: {
      radius: 2,
      size: 'none',
      color: 'transparent',
    },
    height: {
      mobile: '3.5rem',
    },
    outline: {
      size: '1px solid',
      color: colors.FRESSNAPF_TEXT_SECONDARY,
      offset: -1,
    },
    typography: 'body',
  },
  states: {
    hover: {
      outlineWidth: null,
    },
    focus: {
      outlineWidth: 2,
      outlineOffset: null,
    },
    focusVisible: {
      outlineWidth: 2,
      outlineOffset: null,
    },
    disabled: {
      opacity: 0.35,
    },
  },
};
